import { Button, Flex, Tag, Typography } from 'antd'
import type { ColumnsType } from 'antd/es/table'
import { X } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { AvatarWithInitials, ProTableContainer } from 'src/components'

import type { TeamMember } from './types'

const { Text, Title } = Typography

type Props = {
  teamName: string
  breadcrumb: string
  members: TeamMember[]
  owner?: { name: string; title: string }
  onClose: () => void
}

export const TeamMembersPanel = ({
  teamName,
  breadcrumb,
  members,
  owner,
  onClose
}: Props) => {
  const { t } = useTranslation()

  const columns: ColumnsType<TeamMember> = [
    {
      title: t('workspace.orgChart.memberTable.name'),
      dataIndex: 'name',
      key: 'name',
      fixed: 'left',
      render: (name: string) => (
        <Flex align="center" gap={8}>
          <AvatarWithInitials name={name} size={28} />
          <Text>{name}</Text>
        </Flex>
      )
    },
    {
      title: t('workspace.orgChart.memberTable.role'),
      dataIndex: 'role',
      key: 'role',
      render: (role: string) => <Tag>{role}</Tag>
    },
    {
      title: t('workspace.orgChart.memberTable.email'),
      dataIndex: 'email',
      key: 'email'
    }
  ]

  return (
    <div
      style={{
        border: '2px solid #95de64',
        borderRadius: 10,
        padding: 20,
        marginTop: 24
      }}
    >
      <Flex justify="space-between" align="center" style={{ marginBottom: 16 }}>
        <div>
          <Title level={5} style={{ margin: 0 }}>
            {teamName}
          </Title>
          <Text type="secondary" style={{ fontSize: 12 }}>
            {breadcrumb}
          </Text>
        </div>
        <Button
          type="text"
          size="small"
          icon={<X size={16} />}
          onClick={onClose}
        />
      </Flex>

      {owner && (
        <Flex gap={4} style={{ marginBottom: 12 }}>
          <Text type="secondary">
            {t('workspace.orgChart.nodeDetail.owner')}:
          </Text>
          <Text strong>{owner.name}</Text>
        </Flex>
      )}

      <ProTableContainer
        showSearch={false}
        columns={columns}
        dataSource={members}
        rowKey="id"
        pagination={false}
      />
    </div>
  )
}
